import React from "react";
import styled from "styled-components";
import ContentContainer from "../atoms/ContentContainer";
import FormTitle from "../atoms/FormTitle";
import Loader from "../atoms/icons/Loader";
const LoaderWrapper = styled.div `
    position: absolute;
    right: 0;
    top: 0;
`;
const StyledLoader = styled(Loader) `
    width: 28px;
    height: 28px;
`;
const LoadingMessage = ({ title = "Laden...", children, }) => {
    return (React.createElement(ContentContainer, null,
        React.createElement(FormTitle, null,
            title,
            React.createElement(LoaderWrapper, null,
                React.createElement(StyledLoader, null))),
        children));
};
export default LoadingMessage;
